import { useState } from 'react';

export default () => {
  const [readme, setReadme] = useState('');
  return {
    readme,
    setReadme,
  };
};
